import React from 'react'
import { useTranslation } from 'react-i18next'
import { isMobile } from 'react-device-detect'
import { Motif } from '../../types/motifs'
import { useStrapiTranslation } from '../../utils/useStrapiTranslation'
import { InfoWrapper } from './styled'
import MotifSelector from './MotifSelector'

interface Props {
  motif: Motif
}

const MotifInfoSection = ({ motif }: Props) => {
  const { t } = useTranslation()
  const { strapiTranslate } = useStrapiTranslation()

  return (
    <InfoWrapper>
      <div className="data">
        {isMobile && window.innerHeight < 600 ? <MotifSelector motif={motif} /> : null}
        <h1>{strapiTranslate(motif, 'title')}</h1>
        <p className="year-settlement-info">
          {strapiTranslate(motif, 'year')}
          {motif.year && (motif.country || motif.region || motif.settlement) ? ' - ' : ''}
          {strapiTranslate(motif, 'country')}
          {motif.country && motif.region ? ', ' : ''}
          {strapiTranslate(motif, 'region')}
          {(motif.region && motif.settlement) ||
          (motif.country && motif.settlement && !motif.region)
            ? ', '
            : ''}
          {strapiTranslate(motif, 'settlement')}
        </p>
        <h2>{strapiTranslate(motif, 'subtitle')}</h2>
      </div>
      <p className="tags" hidden>
        tags: {motif.tagIds?.length ? motif.tagIds.join(', ') : ''}
      </p>
      <p className="description">{strapiTranslate(motif, 'description')}</p>
    </InfoWrapper>
  )
}

export default MotifInfoSection
